/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './disableInviteCodes.defs.js'
export { main as default } from './disableInviteCodes.defs.js'
